<mat-form-field class="number-filter" [formGroup]="paramsGroup">
  <mat-label>Numeric value</mat-label>
  <input matInput type="number" formControlName="value" />
  <div class="form-field-badge" matTextSuffix>0-9</div>
  @if (paramsGroup.get('value')?.hasError('required')) {
    <mat-error>This field is required</mat-error>
  }
</mat-form-field>
